import React, { useEffect, useState } from 'react'
import { diagonistics } from '../../Assets/dummyDiagons'
import Header from '../Core/Header'
import { useSelector } from 'react-redux'
import { getAllHospitals } from '../../service/operations/api_methods'

const FindHospitals = () => {
    const[list,setList]=useState(diagonistics)
       const token=useSelector((state)=>state?.auth?.token)


      const [hospitalList,sethospitalList]=useState([])
         const [searchkey,setSearchKey]=useState("")
    
         const handleGetAllhospital=async()=>{
            try {
                const res =await getAllHospitals(token)
                console.log('getAllDoctor',res.data.data);
                if(res.status===200){
                    sethospitalList(res.data.data)
                }
                
            } catch (error) {
              console.log(error);
                
            }
         }


            useEffect(() => {
                handleGetAllhospital()
              }, [])
    
  return (
    <div style={{height:"100vh",width:"100%"}}>
        <Header/>
        <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-between",padding:"6px"}}>
            <p style={{color:"white"}}>All registered Hospitals </p>
            <input placeholder='Search hospitals by Adhaar'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
            <p style={{fontSize:"14px",padding:"5px",borderRadius:"6px",backgroundColor:"#fefefe",cursor:"pointer"}}>Register New</p>
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            hospitalList.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}>
                        Add to Assign</p>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item?.hospital_name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{item.Patients}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>License No:{item.license_number}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.Address}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                       
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
     
    </div>
  )
}

export default FindHospitals
